var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9498 12H14.1665C13.7245 12 13.3006 12.1756 12.988 12.4882C12.6754 12.8007 12.4998 13.2246 12.4998 13.6667V17.45M5.83317 2.28333V3.66667C5.83317 4.32971 6.09656 4.96559 6.5654 5.43443C7.03424 5.90327 7.67013 6.16667 8.33317 6.16667C8.7752 6.16667 9.19912 6.34226 9.51168 6.65482C9.82424 6.96738 9.99984 7.3913 9.99984 7.83333C9.99984 8.75 10.7498 9.5 11.6665 9.5C12.1085 9.5 12.5325 9.3244 12.845 9.01184C13.1576 8.69928 13.3332 8.27536 13.3332 7.83333C13.3332 6.91667 14.0832 6.16667 14.9998 6.16667H17.6415M9.1665 17.7917V14.5C9.1665 14.058 8.99091 13.634 8.67835 13.3215C8.36579 13.0089 7.94186 12.8333 7.49984 12.8333C7.05781 12.8333 6.63389 12.6577 6.32133 12.3452C6.00876 12.0326 5.83317 11.6087 5.83317 11.1667V10.3333C5.83317 9.8913 5.65758 9.46738 5.34502 9.15482C5.03245 8.84226 4.60853 8.66666 4.1665 8.66666H1.70817M18.3332 9.5C18.3332 14.1024 14.6022 17.8333 9.99984 17.8333C5.39746 17.8333 1.6665 14.1024 1.6665 9.5C1.6665 4.89763 5.39746 1.16667 9.99984 1.16667C14.6022 1.16667 18.3332 4.89763 18.3332 9.5Z",
    stroke: "#9F9F9F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.9cc46db617b6dd58002fac612d8ce907.svg";
export { ForwardRef as ReactComponent };